import React from 'react';
import Props from '../../Components/Props';
import FormikFields from 'components/FormikFields';
import JSXCode from '../../Components/JSXCode';
import { Form, Formik } from 'formik';
import { CommonIcons } from 'components/Icons';

const TabInput = (props) => {
  //! State

  //! Function

  //! Render
  return (
    <div className='component:TabInput'>
      <Formik initialValues={{ username: '' }} onSubmit={() => {}}>
        {() => {
          return (
            <Form>
              <FormikFields.Input
                name='username'
                label='Username'
                placeholder='Type your username'
                addOnText={<CommonIcons.User />}
                required
              />
            </Form>
          );
        }}
      </Formik>

      <div className='tw-mt-3'>
        <JSXCode
          code={`<Formik initialValues={{ username: '' }} onSubmit={() => {}}>
    {() => {
        return (
        <Form>
            <FormikFields.Input
                name='username'
                label='Username'
                placeholder='Type your username'
                addOnText={<CommonIcons.User />}
                required
            />
        </Form>
        );
    }}
</Formik>
`}
        />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'name',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'label',
            type: 'any',
            default: 'undefined',
          },
          {
            prop: 'placeholder',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'afterOnChange',
            type: '(event) => void',
            default: 'undefined',
          },
          { prop: 'className', type: 'string', default: 'undefined' },
          { prop: 'classNameContainer', type: 'string', default: 'undefined' },
          {
            prop: 'autoFocus',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'disabled',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'required',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'addOnText',
            type: 'any',
            default: 'undefined',
          },
          {
            prop: 'addOnType',
            type: '"prepend" | "append"',
            default: '"append"',
          },
          {
            prop: 'isShowHidePassword',
            type: 'boolean',
            default: 'false',
          },
        ]}
      />
    </div>
  );
};

export default TabInput;
